export const listaAtencaoBasica = [
  {
    id: 1,
    nome: 'Aciclovir 200 mg Comprimido'
  },
  {
    id: 2,
    nome: 'Ácido acetilsalicílico 100 mg Comprimido'
  },
  {
    id: 3,
    nome: 'Ácido fólico 5 mg Comprimido'
  },
  {
    id: 4,
    nome: 'Albendazol 40 mg / ml suspensão oral 10 ml Frasco'
  },
  {
    id: 5,
    nome: 'Albendazol 400 mg Comprimido'
  },
  {
    id: 6,
    nome: 'Alendronato de sódio 70mg Comprimido'
  },
  {
    id: 7,
    nome: 'Alopurinol 100 mg Comprimido'
  },
  {
    id: 8,
    nome: 'Ambroxol 3 mg / ml xarope 120 ml Frasco'
  },
  {
    id: 9,
    nome: 'Amiodarona 200 mg Comprimido'
  },
  {
    id: 10,
    nome: 'Amoxicilina + clavulanato de potássio 250 + 62, 5 mg / 5 ml - 75 ml Frasco'
  },
  {
    id: 11,
    nome: 'Amoxicilina 250 mg / 5 ml 60 ml Frasco'
  },
  {
    id: 12,
    nome: 'Amoxicilina 500 mg Comprimido'
  },
  {
    id: 13,
    nome: 'Amoxicilina 500 mg + clavulanato de potássio 125 mg Comprimido'
  },
  {
    id: 14,
    nome: 'Anlodipina 5mg Comprimido'
  },
  {
    id: 15,
    nome: 'Anlodipino 10 mg Comprimido'
  },
  {
    id: 16,
    nome: 'Atenolol 25mg Comprimido'
  },
  {
    id: 17,
    nome: 'Atenolol 50 mg Comprimido'
  },
  {
    id: 18,
    nome: 'Azitromicina 40 mg / mL suspensão oral 30ml Frasco'
  },
  {
    id: 19,
    nome: 'Azitromicina 500 mg Comprimido'
  },
  {
    id: 20,
    nome: 'Beclometasona 200 mcg inalatório uso oral Frasco'
  },
  {
    id: 21,
    nome: 'Beclometasona 50 mcg inalatório spray nasal Frasco'
  },
  {
    id: 22,
    nome: 'Benzilpenicilinabenzatina 1.200.000UI pó para solução injetável Frasco / Ampola'
  },
  {
    id: 23,
    nome: 'Benzilpenicilina benzatina 600.000UI pó para solução injetável Frasco / Ampola'
  },
  {
    id: 24,
    nome: 'Benzilpenicilina procaina 300.000UI + Benzilpenicilina potássica 100.000UI pó para solução injetável Frasco / Ampola'
  },
  {
    id: 25,
    nome: 'Bromoprida 4 mg / ml 20 ml solução oral gotas Frasco'
  },
  {
    id: 26,
    nome: 'Budesonida 32mcg 120 doses suspensão spray nasal Frasco'
  },
  {
    id: 27,
    nome: 'Cabergolina 0, 5mg Comprimido'
  },
  {
    id: 28,
    nome: 'Captopril 25 mg Comprimido'
  },
  {
    id: 29,
    nome: 'Carbonato de cálcio 1250 mg(equiv 500 mg Ca++) Comprimido'
  },
  {
    id: 30,
    nome: 'Carbonato de cálcio 500mg + Colecalciferol 400 UI Comprimido'
  },
  {
    id: 31,
    nome: 'Carvedilol 3, 125 mg Comprimido'
  },
  {
    id: 32,
    nome: 'Carvedilol 12, 5 mg Comprimido'
  },
  {
    id: 33,
    nome: 'Cefalexina 250 mg / 5 ml pó para suspensão oral 60 ml Frasco Cefalexina 500 mg - cápsula ou comprimido revestido Comprimido'
  },
  {
    id: 34,
    nome: 'Ceftriaxona 500mg uso IV / IM injetável Frasco / Ampola'
  },
  {
    id: 35,
    nome: 'Ciclopentolato 1 % solução ofmálmica 5ml Frasco'
  },
  {
    id: 36,
    nome: 'Ciprofloxacino 500 mg Comprimido'
  },
  {
    id: 37,
    nome: 'Claritromicina 500mg Comprimido'
  },
  {
    id: 38,
    nome: 'Claritromicina 50mg / ml suspensão oral 60ml Frasco'
  },
  {
    id: 39,
    nome: 'Clindamicina 300mg Cápsula'
  },
  {
    id: 40,
    nome: 'Cloreto de sódio 0, 9 % solução nasal 30 ml Frasco'
  },
  {
    id: 41,
    nome: 'Dexametasona 4mg Comprimido'
  },
  {
    id: 42,
    nome: 'Dexametasona 0, 5mg Comprimido'
  },
  {
    id: 43,
    nome: 'Dexametasona 0, 1mg / ml solução oral 100ml Frasco'
  },
  {
    id: 44,
    nome: 'Dexametasona 0, 1 % creme 10 gramas Bisnaga'
  },
  {
    id: 45,
    nome: 'Dexametasona 0, 1 % 5ml solução oftálmica Frasco'
  },
  {
    id: 46,
    nome: 'Dexclorfeniramina 2 mg Comprimido'
  },
  {
    id: 47,
    nome: 'Dexclorfeniramina 0, 4mg / ml solução oral 120ml Frasco'
  },
  {
    id: 48,
    nome: 'Digoxina 0,25mg Comprimido'
  },
  {
    id: 49,
    nome: 'Digoxina 0,05mg / ml elixir oral 60ml Frasco'
  },
  {
    id: 50,
    nome: 'Diltiazem 60 mg Comprimido'
  },
  {
    id: 51,
    nome: 'Dipirona 500 mg Comprimido'
  },
  {
    id: 52,
    nome: 'Dipirona 500 mg / ml solução oral gotas 10 ml Frasco'
  },
  {
    id: 53,
    nome: 'Enalapril 10 mg Comprimido'
  },
  {
    id: 54,
    nome: 'Enalapril 20 mg Comprimido'
  },
  {
    id: 55,
    nome: 'Enalapril 5 mg Comprimido'
  },
  {
    id: 56,
    nome: 'Eritromicina 500 mg Comprimido'
  },
  {
    id: 57,
    nome: 'Eritromicina 50 mg / mL suspensão oral 60ml Frasco'
  },
  {
    id: 58,
    nome: 'Escopolamina, butilbrometo 10mg Comprimido'
  },
  {
    id: 59,
    nome: 'Espiramicina 500mg(1.500.000UI) Comprimido'
  },
  {
    id: 60,
    nome: 'Espironolactona 100 mg Comprimido'
  },
  {
    id: 61,
    nome: 'Espironolactona 25 mg Comprimido'
  },
  {
    id: 62,
    nome: 'Estriol creme vaginal 1mg / g 50 gramas Bisnaga'
  },
  {
    id: 63,
    nome: 'Fenofibrato 200mg Comprimido'
  },
  {
    id: 64,
    nome: 'Fenoterol 5mg / ml solução para inalação 20ml Frasco'
  },
  {
    id: 65,
    nome: 'Fluconazol 150 mg Cápsula'
  },
  {
    id: 66,
    nome: 'Fluoresceina 1% solução oftálmica 3ml Frasco'
  },
  {
    id: 67,
    nome: 'Folinato de cálcio 15mg Comprimido'
  },
  {
    id: 68,
    nome: 'Furosemida 40 mg Comprimido'
  },
  {
    id: 69,
    nome: 'Gabapentina 400mg Comprimido'
  },
  {
    id: 70,
    nome: 'Gentamicina 0,5% solução oftálmica 5ml Frasco'
  },
  {
    id: 71,
    nome: 'Glibenclamida 5 mg Comprimido Glicazida 30 mg comprimido de liberação prolongada Comprimido'
  },
  {
    id: 72,
    nome: 'Hidralazina 25 mg Comprimido'
  },
  {
    id: 73,
    nome: 'Hidroclorotiazida 25 mg Comprimido'
  },
  {
    id: 74,
    nome: 'Hidrocortisona creme 10mg / g 30 gramas Bisnaga'
  },
  {
    id: 75,
    nome: 'Hidróxido de alumínio 60 a 62mg / ml suspensão oral 100ml Frasco'
  },
  {
    id: 76,
    nome: 'Hipromelose 0,3% solução oftálmica 5ml Frasco'
  },
  {
    id: 77,
    nome: 'Ibuprofeno 50mg / ml suspensão oral gotas 30ml Frasco'
  },
  {
    id: 78,
    nome: 'Ibuprofeno 200 mg Comprimido'
  },
  {
    id: 79,
    nome: 'Ibuprofeno 600 mg Comprimido'
  },
  {
    id: 80,
    nome: 'Insulina humana regular 100 UI / ml 10 ml Frasco / Ampola'
  },
  {
    id: 81,
    nome: 'Insulina humana regular 100UI / ml flexpen 3ml Caneta'
  },
  {
    id: 82,
    nome: 'Insulina NPH humana 100 UI / ml 10 ml Frasco / Ampola'
  },
  {
    id: 83,
    nome: 'Insulina NPH humana 100UI / ml flexpen 3ml Caneta'
  },
  {
    id: 84,
    nome: 'Ipratrópio 0,25mg / ml 20ml solução para inalação Frasco'
  },
  {
    id: 85,
    nome: 'Isossorbida dinitrato 5 mg sublingual Comprimido'
  },
  {
    id: 86,
    nome: 'Isossorbida mononitrato 20 mg Comprimido'
  },
  {
    id: 87,
    nome: 'Isossorbida mononitrato 40 mg Comprimido'
  },
  {
    id: 88,
    nome: 'Itraconazol 100mg Cápsula'
  },
  {
    id: 89,
    nome: 'Ivermectina 6 mg Comprimido'
  },
  {
    id: 90,
    nome: 'Levodopa 250 mg + carbidopa 25 mg Comprimido'
  },
  {
    id: 91,
    nome: 'Levodopa 200 mg + benzerazida 50 mg Comprimido'
  },
  {
    id: 92,
    nome: 'Levodopa 100mg + benzerazida 25mg ação prolongada Comprimido'
  },
  {
    id: 93,
    nome: 'Levonorgestrel 0, 15 mg + Etinilestradiol 0, 03 mg Comprimido'
  },
  {
    id: 94,
    nome: 'Levonorgestrel 0, 75 mg Comprimido'
  },
  {
    id: 95,
    nome: 'Levotiroxina 100 mcg Comprimido'
  },
  {
    id: 96,
    nome: 'Levotiroxina 25 mcg Comprimido'
  },
  {
    id: 97,
    nome: 'Levotiroxina 50 mcg Comprimido'
  },
  {
    id: 98,
    nome: 'Loratadina 10 mg Comprimido'
  },
  {
    id: 99,
    nome: 'Loratadina 5 mg / 5mL xarope 100ml Frasco'
  },
  {
    id: 100,
    nome: 'Losartana potássica 50mg Comprimido'
  },
  {
    id: 101,
    nome: 'Medroxiprogesterona acetato 150mg / ml 1ml Frasco / Ampola'
  },
  {
    id: 102,
    nome: 'Metadona 10mg Comprimido'
  },
  {
    id: 103,
    nome: 'Metformina 500 mg Comprimido'
  },
  {
    id: 104,
    nome: 'Metformina 850 mg Comprimido'
  },
  {
    id: 105,
    nome: 'Metildopa 250 mg Comprimido'
  },
  {
    id: 106,
    nome: 'Metoclopramida 10 mg Comprimido'
  },
  {
    id: 107,
    nome: 'Metoclopramida 4 mg / ml gotas 10 ml Frasco'
  },
  {
    id: 108,
    nome: 'Metoprolol 25mg de liberação prolongada Comprimido'
  },
  {
    id: 109,
    nome: 'Metronidazol 250 mg Comprimido'
  },
  {
    id: 110,
    nome: 'Metronidazol 400mg Comprimido'
  },
  {
    id: 111,
    nome: 'Metronidazol 100 mg / g creme vaginal com aplicador Bisnaga'
  },
  {
    id: 112,
    nome: 'Metronidazolbenzoil 40mg / ml 100ml suspensão oral Frasco'
  },
  {
    id: 113,
    nome: 'Miconazol nitrato 2% 30ml loção Frasco'
  },
  {
    id: 114,
    nome: 'Miconazol nitrato 20mg / g 28 gramas creme uso tópico Bisnaga'
  },
  {
    id: 115,
    nome: 'Miconazol 20 mg / g creme vaginal 80 g Bisnaga'
  },
  {
    id: 116,
    nome: 'Neomicina + bacitracina tubo com 10 g Bisnaga'
  },
  {
    id: 117,
    nome: 'Nicotina 14mg Adesivo'
  },
  {
    id: 118,
    nome: 'Nicotina 21mg Adesivo'
  },
  {
    id: 119,
    nome: 'Nicotina 7mg Adesivo'
  },
  {
    id: 120,
    nome: 'Nifedipina 20 mg(Liberação controlada) Comprimido'
  },
  {
    id: 121,
    nome: 'Nistatina 100.000 UI / ml suspensão oral 50 ml Frasco'
  },
  {
    id: 122,
    nome: 'Nitrofurantoina 100mg Comprimido'
  },
  {
    id: 123,
    nome: 'Noretisterona 0, 35mg Comprimido'
  },
  {
    id: 124,
    nome: 'Noretisterona 50mg / ml + Estradiol 5mg / ml 1ml Ampola'
  },
  {
    id: 125,
    nome: 'Óleo mineral puro 100 ml Frasco'
  },
  {
    id: 126,
    nome: 'Omeprazol 20 mg Comprimido'
  },
  {
    id: 127,
    nome: 'Oseltamivir, fosfato 30mg Comprimido'
  },
  {
    id: 128,
    nome: 'Oseltamivir, fosfato 45mg Comprimido'
  },
  {
    id: 129,
    nome: 'Oseltamivir, fosfato 75mg Comprimido'
  },
  {
    id: 130,
    nome: 'Óxido de zinco 150 mg + vitamina D 900 UI / g + vitamina A 5000 UI / 45g Bisnaga'
  },
  {
    id: 131,
    nome: 'Paracetamol 200 mg / mL solução oral gotas 15ml Frasco'
  },
  {
    id: 132,
    nome: 'Paracetamol 500 mg Comprimido'
  },
  {
    id: 133,
    nome: 'Pentoxifilina 400mg Comprimido'
  },
  {
    id: 134,
    nome: 'Permanganato de potássio 100 mg Comprimido'
  },
  {
    id: 135,
    nome: 'Permetrina 1% loção 60ml Frasco'
  },
  {
    id: 136,
    nome: 'Permetrina 5% loção emulsionada 60 mL Frasco'
  },
  {
    id: 137,
    nome: 'Pirimetamina 25mg Comprimido'
  },
  {
    id: 138,
    nome: 'Prednisolona 1,34 mg / mL solução oral 100 mL Frasco'
  },
  {
    id: 139,
    nome: 'Prednisona 20 mg Comprimido'
  },
  {
    id: 140,
    nome: 'Prednisona 5 mg Comprimido'
  },
  {
    id: 141,
    nome: 'Propafenona 300mg Comprimido'
  },
  {
    id: 142,
    nome: 'Propriltiouracil 100mg Comprimido'
  },
  {
    id: 143,
    nome: 'Propranolol 40 mg Comprimido'
  },
  {
    id: 144,
    nome: 'Proximetacaina 5mg / ml solução oftálmica 5ml Frasco'
  },
  {
    id: 145,
    nome: 'Ranitidina 150 mg Comprimido'
  },
  {
    id: 146,
    nome: 'Sais para reidratação pó para solução oral 27, 9 g Envelope'
  },
  {
    id: 147,
    nome: 'Salbutamol 100 mcg aerossol inalatório com 200 doses Frasco'
  },
  {
    id: 148,
    nome: 'Simeticona 75mg / ml solução oral gotas 15ml Frasco'
  },
  {
    id: 149,
    nome: 'Sinvastatina 20 mg Comprimido'
  },
  {
    id: 150,
    nome: 'Sinvastatina 40 mg Comprimido'
  },
  {
    id: 151,
    nome: 'Sulfadiazina 500 mg Comprimido'
  },
  {
    id: 152,
    nome: 'Sulfametoxazol 200 mg + Trimetroprima 40 mg / 5 ml susp.oral 60 ml Frasco'
  },
  {
    id: 153,
    nome: 'Sulfametoxazol 400 mg + trimetoprima 80 mg Comprimido'
  },
  {
    id: 154,
    nome: 'Sulfato Ferroso 12,5 mg / 2, 5ml 100ml xarope Frasco'
  },
  {
    id: 155,
    nome: 'Sulfato ferroso 25 mg / ml solução oral 30 ml Frasco'
  },
  {
    id: 156,
    nome: 'Sulfato Ferroso 40mg de ferro elementar Dragea'
  },
  {
    id: 157,
    nome: 'Timolol 0,5% solução oftálmica 5ml Frasco'
  },
  {
    id: 158,
    nome: 'Varfarina 1mg Comprimido'
  },
  {
    id: 159,
    nome: 'Varfarina 5mg Comprimido'
  },
  {
    id: 160,
    nome: 'Verapamil 80 mg Comprimido'
  },
  {
    id: 161,
    nome: 'Vitamina A + D solução oral gotas 10 ml Frasco'
  },
  {
    id: 162,
    nome: 'Vitamina A 100.000UI Cápsula'
  },
  {
    id: 163,
    nome: 'Vitamina A 200.000UI Cápsula'
  },
  {
    id: 164,
    nome: 'Vitamina B6 100mg Comprimido'
  },
  {
    id: 165,
    nome: 'Vitamina B1 300mg Comprimido'
  },
  {
    id: 166,
    nome: 'Vitamina B12 5000mg solução injeável Ampola'
  },
  {
    id: 167,
    nome: 'Vitamina C solução 200mg / ml solução oral gotas 20ml Frasco'
  },
  {
    id: 168,
    nome: 'Vitamina do complexo B Comprimido'
  },
  {
    id: 169,
    nome: 'Vitaminas do complexo B solução oral gotas 20 ml Frasco'
  }
];

export const listaSaudeMental = [
  { id: 1, nome: 'Ácido Valpróico 250mg Comprimido' },
  { id: 2, nome: 'Ácido Valpróico 500mg Comprimido' },
  { id: 3, nome: 'Amitriptilina 25mg Comprimido' },
  { id: 4, nome: 'Amitriptilina 75mg Comprimido' },
  { id: 5, nome: 'Biperideno 2mg Comprimido' },
  { id: 6, nome: 'Bupropiona 150mg Comprimido' },
  { id: 7, nome: 'Carbamazepina 20mg/ml solução oral 100ml Frasco' },
  { id: 8, nome: 'Carbamazepina 200mg Comprimido' },
  { id: 9, nome: 'Carbonato de lítio 300mg Comprimido' },
  { id: 10, nome: 'Clomipramina 25mg Comprimido' },
  { id: 11, nome: 'Clonazepam 0,5mg Comprimido' },
  { id: 12, nome: 'Clonazepam 2mg Comprimido' },
  { id: 13, nome: 'Clonazepam 2,5mg/ml solução oral gotas 20ml Frasco' },
  { id: 14, nome: 'Clorpromazina 100mg Comprimido' },
  { id: 15, nome: 'Clorpromazina 25mg Comprimido' },
  { id: 16, nome: 'Clorpromazina 40mg/mL solução oral gotas 20ml Frasco' },
  { id: 17, nome: 'Diazepan 10mg Comprimido' },
  { id: 18, nome: 'Diazepan 5mg Comprimido' },
  { id: 19, nome: 'Fenitoína 100mg Comprimido' },
  { id: 20, nome: 'Fenitoina 50mg/ml suspensão oral 120ml Frasco' },
  { id: 21, nome: 'Fenobarbital 100mg Comprimido' },
  { id: 22, nome: 'Fenobartital 40mg/ml solução oral gotas 20ml Frasco' },
  { id: 23, nome: 'Flufenazina 5mg Comprimido' },
  { id: 24, nome: 'Fluoxetina 20mg Comprimido' },
  { id: 25, nome: 'Haloperidol 1mg Comprimido' },
  { id: 26, nome: 'Haloperidol 5mg Comprimido' },
  { id: 27, nome: 'Haloperidol 2mg/mL solução oral gotas 20mL Frasco' },
  { id: 28, nome: 'Haloperidol decanoato 50mg/ml 1ml Ampola' },
  { id: 29, nome: 'Imipramina 25mg Comprimido' },
  { id: 30, nome: 'Levomepromazina 100mg Comprimido' },
  { id: 31, nome: 'Levomepromazina 25mg Frasco' },
  { id: 32, nome: 'Levomepromazina 4% solução oral 20ml Frasco' },
  { id: 33, nome: 'Nitrazepan 5mg Comprimido' },
  { id: 34, nome: 'Nortriptilina 25mg Comprimido' },
  { id: 35, nome: 'Nortriptilina 50mg Comprimido' },
  { id: 36, nome: 'Periciazina 1% solução oral 20ml Frasco' },
  { id: 37, nome: 'Periciazina 4% solução oral 20ml Frasco' },
  { id: 38, nome: 'Periciazina 10mg Comprimido' },
  { id: 39, nome: 'Prometazina 25mg Comprimido' },
  { id: 40, nome: 'Risperidona 1mg Comprimido' },
  { id: 41, nome: 'Risperidona 2mg Comprimido' },
  { id: 42, nome: 'Sertralina 25mg Comprimido' },
  { id: 43, nome: 'Tioridazina 100mg Comprimido' },
  { id: 44, nome: 'Tioridazina 25mg Comprimido' },
  { id: 45, nome: 'Tioridazina 50mg Frasco' },
  { id: 46, nome: 'Trifluoperazina 5mg Comprimido' },
  { id: 47, nome: 'Valproato de sódio 57,6mg/mL solução oral 100mL Frasco' }
];
